import Navbar from "./Navbar/Navbar";

const PageLayout = ({ children }) => {
  return (
    <div className="App">
      <Navbar />
      {children}
    </div>
  );
};

export default PageLayout;
